import clsx from "clsx";
import Script from "next/script";
import { memo, useEffect, useState } from "react";

 function EmbededInstagram(props: { social_media_link: string }) {
  const [embedLoaded, setEmbedLoaded] = useState(false);

  useEffect(() => {
    if (embedLoaded && window.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process();
    }
  }, [props.social_media_link, embedLoaded]);

  return (
    <>
      <Script
        src="https://www.instagram.com/embed.js"
        async
        onLoad={() => {
          setEmbedLoaded(true);
        }}
      ></Script>
      <div
        className={clsx("overflow-hidden hidden", {
          "!block": embedLoaded,
        })}
      >
        <blockquote
          className="instagram-media bg-white xl:rounded-[30px] shadow-sm w-full"
          data-instgrm-permalink={props.social_media_link}
          data-instgrm-version="12"
        ></blockquote>
      </div>

      <noscript>
        <a href={props.social_media_link} target="_blank" rel="noopener">
          View this post on Instagram
        </a>
      </noscript>
    </>
  );
}

export default memo(EmbededInstagram)